// list of random "hardcoded" values used throughout the frontend
// no mo magic numbers and strings
export default {
    ENABLE_NEWSLETTER: false,
    ENABLE_V_VIEW: true,
}